import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextAndImageComponent } from './text-and-image/text-and-image.component';
import { TextModule } from '../text/text.module';
import { EvaButtonModule } from '../eva-button/eva-button.module';
import { TranslateModule } from '@ngx-translate/core';



@NgModule({
  declarations: [TextAndImageComponent],
  imports: [
    CommonModule,
    TextModule,
    EvaButtonModule,
    TranslateModule
  ],
  exports: [
    TextAndImageComponent
  ]
})
export class TextAndImageModule { }
